<app-wg-navbar></app-wg-navbar>
<app-wg-sidebar></app-wg-sidebar>
<div class="working-content" [class.sidebar-visible]="sidebarState.visible()">
  <main>
    <router-outlet></router-outlet>
  </main>
  <app-wg-footer></app-wg-footer>
</div>
